import styled, {keyframes} from 'styled-components';
import {Link} from 'react-router';

interface IActive {
    $active: boolean;
    $focused: boolean;
}

export const MenuLink = styled(Link)<IActive>`
    display: flex;
    align-items: center;
    width: 16rem;
    height: 7rem;
    padding: 0.5rem 1rem;
    color: #e9ecef;
    text-decoration: none;
    border-radius: 8px;
    transition: background-color 0.2s;

    background-color: ${(props) => {
        if (props.$active) return '#008BA1';
        return 'transparent';
    }};

    border: ${(props) => (props.$focused ? '2px solid #007bA1' : '2px solid #666')};

    &:hover {
        background-color: ${({$active}) => ($active ? '#007bB1' : '#2c2c2c')};
    }
`;

export const FullScreen = styled.div<{$focused: boolean; $disable: boolean}>`
    display: flex;
    align-items: center;
    width: 16rem;
    height: 7rem;
    padding: 0.5rem 1rem;
    color: #e9ecef;
    text-decoration: none;
    border-radius: 8px;
    transition: background-color 0.2s;
    border: ${({$focused}) => ($focused ? '2px solid #007bA1' : '2px solid #666')};

    opacity: ${({$disable}) => ($disable ? 0.4 : 1)};
    pointer-events: ${({$disable}) => ($disable ? 'none' : 'auto')};
    filter: ${({$disable}) => ($disable ? 'grayscale(80%)' : 'none')};
    cursor: ${({$disable}) => ($disable ? 'not-allowed' : 'pointer')};
`;

export const FullScreenIcon = styled.img<{$focused: boolean}>`
    width: 2.6rem;
    height: 2.6rem;
    margin-right: 16px;
    opacity: ${($focused) => ($focused ? 1 : 0.7)};
    transition: opacity 0.2s ease;
`;

const LayoutButtonSlideUp = keyframes`
    from {
        transform: translate(0%, 0%);
        visibility: hidden;
        opacity: 0;
    }
    to {
        transform: translate(-50%, -50%);
        visibility: visible;
        opacity: 1;
    }
`;

const LayoutButtonSlideDown = keyframes`
    from {
        transform: translate(-50%, -50%);
        visibility: visible;
        opacity: 1;
    }
    to {
        transform: translate(0%, 0%);
        visibility: hidden;
        opacity: 0;
    }
`;

export const CloseButton = styled.button<{$focused: boolean; $visible: boolean}>`
    position: fixed;
    top: 70px;
    left: 180px;
    z-index: 999;
    background-color: rgba(255, 255, 255, 0.2);
    color: #fff;
    border: none;
    border-radius: 10px;
    width: 300px;
    height: 80px;
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: ${({$visible}) => ($visible ? LayoutButtonSlideUp : LayoutButtonSlideDown)} 0.5s forwards;

    &:hover {
        background-color: ${({$focused}) => ($focused ? '#fff' : 'rgba(255, 255, 255, 0.3)')};
    }
`;

export const Icon = styled.img<IActive>`
    width: 2.6rem;
    height: 2.6rem;
    margin-right: 16px;
    filter: ${({$active}) => ($active ? 'brightness(0) invert(1)' : 'none')};
    opacity: ${(props) => (props.$active || props.$focused ? 1 : 0.7)};
    transition: opacity 0.2s ease;
`;

export const Label = styled.span<{$focused: boolean}>`
    font-size: 2.2rem;
    font-weight: ${(props) => (props.$focused ? '600' : '400')};
    color: #fff;
    transition: all 0.2s ease;
`;
